import React from 'react';
import PropTypes from 'prop-types';
import ContentBody from './ContentBody';
import styled from 'styled-components';
import img from '../../images/instore/main-bg.jpg';
import { camelize } from '../../utils';

const StyledPage = styled.div`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 992px;
  &:before {
    z-index: ${props => (props.cameraBackground ? 0 : -1)};
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    background: ${props =>
        props.liveARMode ? '' : 'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%)'},
      ${props =>
        props.cameraBackground
          ? 'url(null)'
          : props.imageBackground
          ? 'url(' + require(`../../images/customers/${props.imageBackground}`) + ')'
          : `url(${img})`};
    background-size: 200% 200%, cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: background-size 0.25s ease-out, filter 0.25s ease-out;
    filter: ${props => props.rstyle.filter};
  }
`;

const Page = props => {
  const {
    style: { content: content = { margins: 60 }, background: background = { filter: null } } = {},
    cameraBackground,
    imageBackground,
    liveARMode,
    components,
    name,
  } = props;

  return (
    <StyledPage
      key={'page'}
      rstyle={background}
      liveARMode={liveARMode}
      cameraBackground={cameraBackground}
      imageBackground={imageBackground}
      className={`revieve-page revieve-page-${camelize(name)}`}
    >
      <ContentBody rstyle={content} components={components} />
    </StyledPage>
  );
};

Page.propTypes = {
  header: PropTypes.object,
  footer: PropTypes.object,
  components: PropTypes.arrayOf(PropTypes.element),
  name: PropTypes.string,
  style: PropTypes.object,
  liveARMode: PropTypes.bool,
};

Page.defaultProps = {
  header: {},
  footer: {},
  components: [],
  name: 'Default page',
  style: {},
  liveARMode: false,
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/instore/Page.js